import { formatDateTimeUTC } from '@/helpers/dateHelpers/dateHelpers';
import { TableConfigItemsListType } from '@/components/Table/types/types';
import { convertCentsToDollars } from '@/helpers/formatHelpers';
import InvoicesIcon from './images/InvoicesIcon.svg?react';
import { SinglePaymentInvoiceType } from '@/api/v1/billing/getSinglePaymentInvoicesApi';
import { SINGLE_PAYMENT_INVOICE_STATUS, SinglePaymentInvoiceStatus } from './SinglePaymentInvoiceStatus';
import { Box } from '@/components/Box/Box';
import { UtcTooltip } from '@/components/UtcTooltip/UtcTooltip';

export const INVOICE_TABLE_CONFIG: TableConfigItemsListType<SinglePaymentInvoiceType> = [
  {
    key: 1,
    name: 'date_created',
    header: 'DATE',
    width: '25%',
    hasSort: true,
    tooltip: <UtcTooltip message='Date is recorded in UTC' />,
    getValue({ date_created }) {
      const formattedDate = formatDateTimeUTC(date_created);

      return { value: formattedDate, title: formattedDate };
    },
  },
  {
    key: 2,
    name: 'quantity',
    header: 'DESCRIPTION',
    width: '15%',
    hasSort: true,
    getValue({ quantity }) {
      const formattedDescription = quantity > 1 ? `${quantity} wires` : `${quantity} wire`;

      return { value: formattedDescription };
    },
  },
  {
    key: 3,
    name: 'final_amount',
    header: 'AMOUNT',
    width: '15%',
    hasSort: true,
    getValue({ final_amount }) {
      const formattedAmount = convertCentsToDollars(final_amount);

      return { value: formattedAmount };
    },
  },
  {
    key: 4,
    name: 'status',
    header: 'STATUS',
    width: '15%',
    hasSort: true,
    getValue({ status }) {
      return {
        value: <SinglePaymentInvoiceStatus status={status} />,
      };
    },
  },
  {
    key: 5,
    name: 'error_message',
    header: 'INFORMATION',
    width: '18%',
    getValue({ status, error_message }) {
      if (status === SINGLE_PAYMENT_INVOICE_STATUS.PAID) {
        return { value: '—' };
      }

      return {
        value: error_message,
        title: error_message,
      };
    },
  },
  {
    key: 6,
    name: 'invoice',
    header: 'RECEIPT / INVOICE',
    width: '12%',
    getValue({ status, stripe_invoice_url }) {
      if (status === SINGLE_PAYMENT_INVOICE_STATUS.FAILED) {
        return { value: '—' };
      }

      return {
        value: (
          <Box onClick={() => window.open(stripe_invoice_url, '_blank')}>
            <InvoicesIcon />
          </Box>
        ),
      };
    },
  },
];
